import React from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const logos = [
  'TechCorp',
  'ShopEasy',
  'GrowthHub',
  'FinServe',
  'CloudNine',
  'DataPulse',
];

export const LogoBar = () => {
  const [ref, isVisible] = useScrollAnimation(0.2);

  return (
    <section ref={ref} className="py-16 border-t border-b border-border/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0 }}
          animate={isVisible ? { opacity: 1 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center text-sm text-muted-foreground mb-10 font-body tracking-wide uppercase"
        >
          Trusted by growing businesses across India
        </motion.p>

        <div className="flex flex-wrap justify-center items-center gap-8 lg:gap-16">
          {logos.map((name, i) => (
            <motion.div
              key={name}
              initial={{ opacity: 0, y: 10 }}
              animate={isVisible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="flex items-center gap-2 opacity-40 hover:opacity-70 transition-opacity duration-300"
            >
              <div className="w-8 h-8 rounded-md bg-muted flex items-center justify-center">
                <span className="text-xs font-bold text-muted-foreground font-heading">
                  {name.charAt(0)}
                </span>
              </div>
              <span className="text-sm font-medium text-muted-foreground font-heading hidden sm:block">
                {name}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
